var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"note-wrapper"},[_c('div',{ref:"note",staticClass:"note keep-whitespaces",class:{ expanded: _vm.isExpanded }},[_vm._v(" "+_vm._s(_vm.note)+" ")]),(_vm.showToggle)?_c('div',{staticClass:"toggle-button text-sm",on:{"click":_vm.toggleNote}},[_vm._v(" "+_vm._s(_vm.isExpanded ? 'Show less' : 'Show all')+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }